<template>
  <md-dialog
    ref="dialog"
    @close="$emit('close')"
  >
    <md-dialog-title>
      Добавление ссылки на источник
    </md-dialog-title>
    <md-dialog-content class="source-dialog-content">
      <source-dialog-form
        :value="content"
        @input="setContent"
      ></source-dialog-form>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button
        class="md-primary"
        @click="onCancel"
      >Отмена</md-button>
      <md-button
        v-if="action === 'add'"
        class="md-primary"
        @click="onAdd"
      >Добавить</md-button>
      <md-button
        v-else
        class="md-primary"
        @click="onSave"
      >Сохранить</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import _ from 'lodash'

import SourceDialogForm from './SourceDialogForm.vue'

export default {
  name: 'SourceDialogView',
  components: {
    SourceDialogForm
  },
  props: {
    content: Object,
    action: String
  },
  data () {
    return {
    }
  },
  methods: {
    onCancel () {
      this.$refs.dialog.close()
      this.$emit('cancel')
    },
    onAdd () {
      this.$refs.dialog.close()
      this.$emit('add-complete')
    },
    onSave () {
      this.$refs.dialog.close()
      this.$emit('edit-complete')
    },
    open () {
      this.$nextTick(() => {
        this.$refs.dialog.open()
      })
    },
    setContent (values) {
      this.$emit('set-content', values)
    }
  }
}
</script>

<style lang="sass">
.source-dialog-content
  width: 900px
  .load-source
    cursor: pointer
    margin: 0px
</style>


// WEBPACK FOOTER //
// SourceDialogView.vue?3d0e30c9